module.exports = __webpack_public_path__ + "img/autorizadores.e65c8c9d.svg";